import React, { useId } from "react";

export default function DynamicUspSection({ aiData, onAction }) {
  if (!aiData?.usp) return null;

  return (
    <section className="dynamic-usp-section">
      <div className="container">
        <div className="row align-items-end justify-content-between dynamic-usp-heading">
          <div className="col-lg-6">
            <span className="main-title dynamic-usp-eyebrow">{aiData?.usp.eyebrow}</span>
            <h2 className="heading">{aiData?.usp?.title}</h2>
          </div>
          <div className="col-lg-5">
            <p className="dynamic-usp-intro">{aiData?.usp?.description}</p>
          </div>
        </div>
        <div className="row dynamic-usp-cards">
          {aiData?.usp?.items.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <article className="dynamic-usp-card">
                <h3>{item?.title}</h3>
                <p className="dynamic-usp-description">{item?.description}</p>
                <div className="dynamic-usp-build">
                <p className="dynamic-usp-build-label">Build:</p>
                <div className="dynamic-usp-tags" dangerouslySetInnerHTML={{ __html: item?.skills?.[0]}} />
              </div>
              </article>
            </div>
          ))}
        </div>
        <div className="dynamic-usp-action text-center">
          <button type="button" className="default-btn" onClick={onAction}>{aiData?.usp?.buttonText}</button>
        </div>
      </div>
    </section>
  );
}
